import { DATEPICKER_MAX_YEARS_SINCE } from '../config/constants';

export const datePickerMinDate = () => {
  const currentYear = new Date().getFullYear();
  const minDate = new Date(currentYear - DATEPICKER_MAX_YEARS_SINCE, 0, 1);
  return minDate.toISOString().slice(0, 10);
};
